import styled from 'styled-components';

export const ActivitiesWrapper = styled.div`
    .category {
        margin-top: 10px;
        font-weight: bold;
    }
`;

export const MismatchWrapper = styled.div`
    color: red;

    .mismatch-header {
        display: flex;
        justify-content: space-between;
    }

    .reject-or-accept-buttons {
        display: flex;
        flex-direction: row-reverse;
    }
`;

export const MismatchHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin-right: 1rem;

    .first-cell {
        width: 70%;
    }
`;
